module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-up-alt-f71ef820.svg";